// Packages
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

// Components
import useLayouts from "../../../layouts";
import useComponents from "../../../components";

// Api
import useApi from "../../../../api";

// Helpers
import useHelpers from "../../../../helpers";

const PromptConfigMain = () => {
  // Api
  const { useActions } = useApi();
  const { useConfigurationActions } = useActions();
  const { actGetConfiguration, actSaveConfiguration } = useConfigurationActions();

  // Helpers
  const { useQuickFunctions } = useHelpers();
  const { useToast } = useQuickFunctions();
  const { success, error } = useToast();

  // Components
  const {
    ContentWrappers,
    TextAreaFieldControlled,
    useButtons,
    Typography,
    Toast,
  } = useComponents();

  const { PrivateContentLayout } = useLayouts();
  const { DefaultButton } = useButtons();

  // Form control with default values
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      systemPrompt: "",
    },
  });

  // Load configuration on mount
  useEffect(() => {
    const onSuccess = (response) => {
      if (response?.data?.value) {
        reset({
          systemPrompt: response.data.value,
        });
      }
    };

    const onError = (err) => {
      console.error("Error loading configuration:", err);
    };

    actGetConfiguration("QUESTION_SYSTEM_PROMPT", onSuccess, onError)();
  }, []);

  const onSuccess = (response) => {
    success(<Toast text="Configuración guardada correctamente" />, {
      toastId: 0,
    });
  };

  const onError = (err) => {
    error(<Toast text="Error al guardar la configuración" />, {
      toastId: 0,
    });
  };

  const onSubmit = (data) => {
    const payload = {
      key: "QUESTION_SYSTEM_PROMPT",
      value: data.systemPrompt,
    };

    actSaveConfiguration({ data: payload }, onSuccess, onError)();
  };

  return (
    <PrivateContentLayout>
      <ContentWrappers gridColums={["1fr"]} contentWidth="90%" as="section">
        <div className="px-8 pt-10 pb-12 bg-white rounded-lg">
          {/* Header with title and save button */}
          <div className="flex justify-between items-center mb-8">
            <Typography variant="h3">Configuración de IA para generación de preguntas</Typography>
            <DefaultButton color="secondary" onClick={handleSubmit(onSubmit)}>
              Guardar
            </DefaultButton>
          </div>

          {/* Form */}
          <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
            {/* System Prompt Textarea */}
            <div>
              <TextAreaFieldControlled
                label="System Prompt"
                id="systemPrompt"
                name="systemPrompt"
                control={control}
                resize="true"
                minRows={20}
                placeholder="Ingrese el system prompt para configurar el comportamiento del modelo para generar preguntas."
                required={true}
              />
            </div>
          </form>
        </div>
      </ContentWrappers>
    </PrivateContentLayout>
  );
};

export default PromptConfigMain;
